const TYPES = {
  OPENING_PACKAGE: 'opening_package',
  WALL_OPENING: 'wall_opening',
  WINDOW_OPENING: 'window_opening',
  WINDOW_GLASS: 'window_glass',
  OPENINGS_TRIM: 'openings_trim',
  LEFT_SHUTTER: 'left_shutter',
  RIGHT_SHUTTER: 'right_shutter',
  SPLIT: 'split',
  FOUNDATION: 'foundation',
  LEFT_TRIM: 'left_trim',
  RIGHT_TRIM: 'right_trim',
  TOP_TRIM: 'top_trim',
  BOTTOM_TRIM: 'bottom_trim',
  LEFT_OUTSIDE_CORNER_TRIM: 'left_outside_corner_trim',
  RIGHT_OUTSIDE_CORNER_TRIM: 'right_outside_corner_trim',
  PARENT: 'parent',
};

export default {
  ...TYPES,
  WALL_TYPES: [
    TYPES.SPLIT,
    TYPES.FOUNDATION,
    TYPES.LEFT_OUTSIDE_CORNER_TRIM,
    TYPES.RIGHT_OUTSIDE_CORNER_TRIM,
    TYPES.TOP_TRIM,
    TYPES.BOTTOM_TRIM,
  ],
  OPENING_PACKAGE_TYPES: [
    TYPES.OPENINGS_TRIM,
    TYPES.LEFT_SHUTTER,
    TYPES.RIGHT_SHUTTER,
    TYPES.WALL_OPENING,
    TYPES.WINDOW_OPENING,
    TYPES.WINDOW_GLASS,
  ],
};
